import { ReactNode, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy, faCheck } from '@fortawesome/pro-regular-svg-icons'
import Typography from '@mui/material/Typography'
import { useStyles } from './DetailField.styles'

interface DetailFieldProps {
  label: string
  value?: ReactNode
  copyValue?: string | null
  fullWidth?: boolean
}

const PLACEHOLDER = '-'

export const DetailField = ({
  label,
  value,
  copyValue,
  fullWidth = false,
}: DetailFieldProps) => {
  const { classes, cx } = useStyles()
  const [copied, setCopied] = useState(false)

  const onCopy = () => {
    if (!copyValue) return
    navigator.clipboard?.writeText(copyValue)
    setCopied(true)
    window.setTimeout(() => setCopied(false), 1500)
  }

  const isEmpty = value == null || value === ''

  return (
    <div className={cx(classes.field, fullWidth && classes.fullWidth)}>
      <Typography component="span" className={classes.label}>
        {label}
      </Typography>
      <div className={classes.valueRow}>
        {isEmpty ? (
          <Typography component="span" className={classes.value}>
            {PLACEHOLDER}
          </Typography>
        ) : typeof value === 'string' ? (
          <Typography component="span" className={classes.value}>
            {value}
          </Typography>
        ) : (
          value
        )}
        {copyValue && !isEmpty && (
          <button
            type="button"
            className={classes.copy}
            onClick={onCopy}
            aria-label={`Copy ${label}`}
          >
            <FontAwesomeIcon icon={copied ? faCheck : faCopy} />
          </button>
        )}
      </div>
    </div>
  )
}
